import { useState } from "react";
import { Link } from "react-router-dom";
import TeamLogo from "../../components/shared/TeamLogo";
import CreateTeamModal from "./CreateTeamModal";
import "../client/ClientLayout.css";
import "./CoachPages.css";

// Root of the Teams tab for a multi-team coach (2+ LeagueTeams rows) — the
// `/coach` index route renders this instead of the roster directly once
// there's more than one team (see CoachPlayersPage's dispatcher). One card
// per team (name, league name, player count); tapping pushes
// `/coach/teams/:teamId` for that team's roster. Mirrors iOS's
// CoachTeamsScreen.

export default function CoachTeamsPage({ teams, onCreated }) {
  const [showCreateTeam, setShowCreateTeam] = useState(false);

  return (
    <div>
      <div className="coach-page-header">
        <div>
          <h1 className="client-h1">My Teams</h1>
          <p className="client-subtitle">{teams.length} team{teams.length === 1 ? "" : "s"}</p>
        </div>
        {/* Parity with iOS CoachTeamsScreen: before this, creating a team was
            only reachable from the zero-team state, so a coach could never
            self-create a second one. */}
        {onCreated && (
          <button className="client-button" onClick={() => setShowCreateTeam(true)}>+ Create Team</button>
        )}
      </div>

      <div className="coach-roster-list">
        {teams.map((t) => (
          <Link key={t.teamId} to={`teams/${t.teamId}`} className="coach-roster-row">
            <TeamLogo name={t.teamName} logoUrl={t.logoUrl} size={36} />
            <span className="coach-roster-name">{t.teamName || "Unnamed Team"}</span>
            <span className="coach-roster-meta">
              {t.leagueName ? `${t.leagueName} · ` : ""}
              {t.playerCount ?? 0} player{(t.playerCount ?? 0) === 1 ? "" : "s"}
            </span>
          </Link>
        ))}
      </div>

      {showCreateTeam && (
        <CreateTeamModal
          onClose={() => setShowCreateTeam(false)}
          onCreated={() => { setShowCreateTeam(false); onCreated(); }}
        />
      )}
    </div>
  );
}
